import { get, post } from '../axios'

export function redirect_list_post(map, option) {
  return post(`${process.env.VUE_APP_COMMON}/redirect/list`, map, option)
}

export function redirect_delete_get(map, option) {
  return get(
    `${process.env.VUE_APP_COMMON}/redirect/delete/${map.id}`,
    map,
    option
  )
}

export function redirect_add_post(map, option) {
  return post(`${process.env.VUE_APP_COMMON}/redirect/add`, map, option)
}

export function redirect_export_post(map, option) {
  return post(`${process.env.VUE_APP_COMMON}/redirect/export`, map, option)
}

export function redirect_import_post(map, option) {
  return post(`${process.env.VUE_APP_COMMON}/redirect/import`, map, option)
}
